
let api = "/api"

if(process.env.NODE_ENV==="production" || process.env.NODE_ENV === "test"){
    api=""
}

export default  api